export default "__VITE_ASSET__a0a19c7a__"